import React from 'react';

const Footer = () => {
  const links = {
    meusPedidos: "https://www.paws.com.br/account/login/",
    contato: "https://www.paws.com.br/contato",
    devolucao: "https://www.paws.com.br/trocas-e-devolucoes/", 
    quemSomos: "https://www.paws.com.br/a-paws-e-confiavel/", 
    privacidade: "https://www.paws.com.br/politica-de-privacidade/",
  };

  return (
    <footer style={styles.footer}>
      <div style={{maxWidth: '1200px', margin: '0 auto'}}>
        
        <h3 style={{color: '#333', marginBottom: '20px'}}>PAWS</h3>

        <ul style={styles.linkList}>
          <li><a href={links.meusPedidos} target="_blank" rel="noreferrer" style={styles.link}>MEUS PEDIDOS</a></li>
          <li><a href={links.contato} target="_blank" rel="noreferrer" style={styles.link}>CONTATO</a></li>
          <li><a href={links.devolucao} target="_blank" rel="noreferrer" style={styles.link}>POLÍTICA DE DEVOLUÇÃO</a></li>
          <li><a href={links.quemSomos} target="_blank" rel="noreferrer" style={styles.link}>A PAWS É CONFIÁVEL?</a></li>
          <li><a href={links.privacidade} target="_blank" rel="noreferrer" style={styles.link}>POLÍTICA DE PRIVACIDADE</a></li>
        </ul>

        <div style={{marginTop: '30px', borderTop: '1px solid #ddd', paddingTop: '20px'}}>
          <p style={{fontSize: '0.9rem'}}>Email: contato@paws.com.br</p>
          <a href={links.whatsapp} target="_blank" rel="noreferrer" style={styles.wppBtn}>
          </a>
        </div>

        <p style={{marginTop: '40px', fontSize: '0.7rem', color: '#999'}}>
          © 2026 PAWS - Todos os direitos reservados.
        </p>

      </div>
    </footer>
  );
};

const styles = {
  footer: { backgroundColor: '#fff', padding: '60px 20px', textAlign: 'center', marginTop: '50px', borderTop: '1px solid #eee' },
  linkList: { listStyle: 'none', padding: 0 },
  link: { display: 'block', margin: '10px 0', textDecoration: 'none', color: '#555', fontWeight: 'bold', fontSize: '0.9rem' },
  wppBtn: { 
    display: 'inline-block', marginTop: '15px', backgroundColor: '#25D366', color: '#fff', 
    padding: '8px 20px', borderRadius: '20px', textDecoration: 'none', fontWeight: 'bold' 
  }
};

export default Footer;